
import { Outlet } from 'react-router-dom';
import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useAppDispatch } from '../../../app/store';
import { fetchAllConfigs } from '../../configs/logic/Thunks';
import PlannedMaintenanceBanner from '../../maintenance/components/PlannedMaintenanceBanner';
const PageLayout: React.FC = () => {

  const auth = useAuth();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if(auth.isAuthenticated) {
      dispatch(fetchAllConfigs())
    }
  }, [auth.isAuthenticated, dispatch])

return (
  <div className="flex flex-1 flex-col overflow-hidden h-full">
    <PlannedMaintenanceBanner />

    <div className="flex flex-1 overflow-hidden">
      <Outlet />
    </div>
  </div>
);
}

export default PageLayout;